






import {Prop, Vue} from "vue-property-decorator";

export default class NoBillingExistence extends Vue {

}
